import { FC } from 'react';
import Container from 'components/container';
import style from './InfoDialog.module.scss';
import { Dialog } from '@mui/material';
import { Body, Heading } from 'components/text';
import { CloseIcon, LittleEmperorsIcon } from 'components/icons';
import { colorConstants } from 'data/constants';

type InfoDialog = {
  title?: string;
  open: boolean;
  subHeading?: string;
  handleClose?: () => void;
};

const InfoDialog: FC<InfoDialog> = ({
  open,
  title,
  subHeading,
  handleClose,
}) => {
  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth={'sm'}
      PaperProps={{ style: { borderRadius: 0 } }}
    >
      <Container className={style.container}>
        <Container className={style.closeIconWrapper}>
          <div onClick={handleClose} className={style.closeIcon}>
            <CloseIcon />
          </div>
        </Container>
        <LittleEmperorsIcon
          color={colorConstants.black}
          className={style.logo}
        />

        <Heading as="h4" mt={15}>
          {title}
        </Heading>
        <Body className={style.subHeading}>{subHeading}</Body>
      </Container>
    </Dialog>
  );
};

export default InfoDialog;
